import React from 'react'

interface ProgressBarProps {
  label: string
  value: number
  bgColor: string
}

const ProgressBar: React.FC<ProgressBarProps> = ({ label, value, bgColor }) => {
  return (
    <div>
      <p className="pb-2 text-sm">{label}</p>
      <div className="h-[6px] w-full max-w-full overflow-hidden rounded-3xl bg-gray-400">
        <div
          className={`h-full ${bgColor}`}
          style={{ width: `${(value / 10) * 100}%` }}
        />
      </div>
    </div>
  )
}

export default ProgressBar
